
import { cn } from "@/lib/utils";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export type SignatureStyle = "vector_illustration/line_art" | "icon/outline";

const stylePresets = [
  {
    id: "vector_illustration/line_art" as const,
    name: "Feather",
  },
  {
    id: "icon/outline" as const,
    name: "Pen",
  }
];

interface StyleSelectorProps {
  style: SignatureStyle;
  onStyleChange: (style: SignatureStyle) => void;
  disabled?: boolean;
}

export const StyleSelector = ({ style, onStyleChange, disabled = false }: StyleSelectorProps) => {
  return (
    <ToggleGroup 
      type="single" 
      value={style}
      onValueChange={(value) => {
        if (!disabled && value) {
          onStyleChange(value as SignatureStyle);
        }
      }}
      className={cn(
        "bg-white rounded-2xl p-1.5 flex h-[80px] md:h-20",
        disabled && "opacity-50 cursor-not-allowed"
      )}
    >
      {stylePresets.map((preset) => (
        <ToggleGroupItem
          key={preset.id}
          value={preset.id}
          disabled={disabled}
          className={cn(
            "h-full px-6 rounded-xl transition-all duration-200",
            "text-xl font-normal",
            "data-[state=on]:bg-black data-[state=on]:text-white",
            "data-[state=off]:text-gray-500 data-[state=off]:hover:text-gray-800 data-[state=off]:hover:bg-gray-50",
            disabled && "cursor-not-allowed"
          )}
        >
          {preset.name}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};
